import { useNavigate, useSearchParams } from "react-router-dom"
import { memo, useEffect, useMemo } from "react"
import { useActions } from "../../../hooks/useActions"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { Flex, Space, Spin, Table, message } from "antd"
import useProjectDataColumns from "../hooks/UseProjectDataKeywordColumns"
import { TableProps } from "antd"
import { IProjectDataKeywords } from "../types/projectDataKeywords.types"
import { routePath } from "../../../router/types"
import AddKeyword from "./AddKeyword"
import useMaxRows from "../../../hooks/useMaxRows"

const MemoTable = memo<TableProps<IProjectDataKeywords>>(Table)

const ProjectDataKeywordsConteiner: React.FC = () => {
  const [searchParams] = useSearchParams()
  const projectId = searchParams.get("projectId")

  const rowCount = useMaxRows({ offset: 250 })

  const { getProjectDataKeywords } = useActions()
  const { projectDataKeywords, loading, error } = useTypedSelector(
    (state) => state.projectDataKeywords
  )
  const navigate = useNavigate()

  useEffect(() => {
    if (!projectId) {
      navigate(routePath.PROJECTS)
      return
    }

    getProjectDataKeywords(projectId)
  }, [projectId])

  useEffect(() => {
    if (error) {
      message.error(error)
    }
  }, [error])

  // Hook must be called at the top level, not inside useMemo
  const columns = useProjectDataColumns(projectDataKeywords)

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Flex vertical align="flex-start">
        <AddKeyword />
      </Flex>
      <Flex justify="center" style={{ width: "100%" }}>
        {loading ? <Spin /> : null}
      </Flex>
      {!loading ? (
        <MemoTable
          dataSource={projectDataKeywords}
          columns={columns}
          pagination={{
            pageSize: rowCount,
          }}
        />
      ) : null}
    </Space>
  )
}

export default ProjectDataKeywordsConteiner
